import {CdAddedMeasureDetailOption} from '../../../interfaces/care/cd-care-plan/cd-added-measure-detail-option';


export class CdAddedMeasureDetailOptionFactory {
  public static fromObject(cdAddedMeasureDetailOption: any): CdAddedMeasureDetailOption {
    return new class implements CdAddedMeasureDetailOption {
      cdItemType: number = cdAddedMeasureDetailOption.type;
      definition: string = cdAddedMeasureDetailOption.definition;
      id: number = cdAddedMeasureDetailOption.id;
      isAdded: boolean = cdAddedMeasureDetailOption.is_added;
      itemId: number = cdAddedMeasureDetailOption.c_care_plan_item_able_id;
      name: string = cdAddedMeasureDetailOption.name;
      taxonomy: string = cdAddedMeasureDetailOption.taxonomy;
      comment: string = cdAddedMeasureDetailOption.comment;
    };
  }

  public static fromArray(cdAddedMeasureDetailOptions: any[]): CdAddedMeasureDetailOption[] {
    return cdAddedMeasureDetailOptions.map(
      _cdAddedMeasureDetailOption => CdAddedMeasureDetailOptionFactory.fromObject(_cdAddedMeasureDetailOption)
    );
  }
}
